<template>
    <div class="create-instance">
        <!-- TODO SUPPRIMER CETTE VUE -->
        <v-dialog
            :value="isOpened"
            width="550"
            :persistent="true"
            @input="v => v || inputEvent()"
            content-class="create-instance-dialog"
        >
            <template v-slot:activator="{ on }"></template>
            <v-card dark>
                <!-- TODO n'afficher le header que l'instance doit etre redeployée, champ à créer sur le model datamodel -->
                <div v-if="instanceSelected.instance_updated" class="header">
                    <v-container
                        fluid
                        id="create-instance-header"
                    >
                        <v-row
                            align="center"
                        >
                            <v-col
                                cols="3"
                                sm="2"
                                class="centered-button"
                            >
                                <v-icon large dark>error_outline</v-icon>
                            </v-col>
                            <v-col
                                cols="9"
                                sm="10"
                            >
                                <span>
                                    {{$t('instance.instance_list.deploy_required')}}
                                </span>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <v-card-title primary-title class="title-container">
                    <h2 class="create-instance-headline">
                        {{ $t('instance.instance_list.create_instance.create') }}
                    </h2>
                    <div @click="closeDialog" class="cross-close-dialog">
                        <button><img src="static/img/Cross.svg"></button>
                    </div>
                </v-card-title>
                <v-form
                    light
                    v-model="instanceDetailsFormValid"
                    :lazy-validation="instanceSelected.uid !== undefined"
                    v-on:submit.prevent
                    ref='detailsForm'
                >
                    <v-container
                        fluid
                        id="create-instance-container"
                    >
                    <!--
                        TODO : Check if vuetify 2.6 new grid system with v-row/v-col
                        is relevant here
                        https://vuetifyjs.com/en/getting-started/upgrade-guide/#grid
                    -->
                        <div
                            class="input-width"
                        >
                            <h2 class="create-instance-title" style="margin-top: 23px;">
                                {{$t('instance.instance_list.create_instance.settings_title')}}
                            </h2>
                            <v-text-field
                                v-model="instanceName"
                                :rules="instanceNameRules"
                                :label="$t('instance.instance_list.create_instance.instance_name')"
                                required
                                color="light-blue lighten-2"
                            ></v-text-field>
                            <v-flex xs12>
                                <v-select
                                    :label="$t('instance.instance_list.create_instance.modelisation_name')"
                                    v-model="selectedVersion"
                                    :rules="selectedVersionRules"
                                    :items="sortedModelisation"
                                    item-text="label"
                                    item-value="uid"
                                    required
                                    :menu-props="{'light': true}"
                                ></v-select>
                            </v-flex>
                            <v-flex xs8>
                                <span class="create-instance-select-label">
                                    {{$t('instance.instance_list.create_instance.datamodel_title')}}
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <i v-on="on" aria-hidden="true" class="v-icon material-icons theme--dark" style="font-size: 16px; color: #2196F3; caret-color: rgb(158, 158, 158);">info</i>
                                    </template>
                                    <span>{{$t('instance.instance_list.create_instance.version_description_text')}}</span>
                                </v-tooltip>
                            </v-flex>
                            <!-- Pas utiliser pour le moment donc désactivé -->
                            <!-- <v-switch
                                class="create-instance-status-switch"
                                v-model="wantedStateIsOnline"
                                :label="wantedStateIsOnline ? 'Online': 'Offline'"
                                color="light-blue lighten-2"
                            ></v-switch> -->
                        </div>
                        <div
                            class="input-width"
                        >
                            <h2 class="create-instance-title">
                                {{$t('instance.instance_list.create_instance.admin_title')}}
                            </h2>
                            <v-text-field
                                v-model="adminEmail"
                                :rules="adminEmailRules"
                                label="Email"
                                required
                                color="light-blue lighten-2"
                            ></v-text-field>
                            <div class="email-descr-container">
                                <i
                                    aria-hidden="true"
                                    class="v-icon material-icons theme--dark"
                                    style="font-size: 16px; color: #FF9800;"
                                >
                                    info
                                </i>
                                <span class="email-description">{{$t('instance.instance_list.create_instance.admin_email_text')}}</span>
                            </div>
                        </div>
                    </v-container>
                </v-form>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout justify-end class="dialog-confirm-buttons">
                        <div
                            class="btn-margin"
                        >
                            <v-btn
                                @click="closeDialog"
                            >
                                {{ $t('instance.instance_list.create_instance.cancelCloseDialog')}}
                            </v-btn>
                        </div>
                        <div>
                            <v-btn
                                :disabled="!instanceDetailsFormValid"
                                :loading="sendingRequest"
                                color="info"
                                :dark="instanceDetailsFormValid"
                                @click="validateDetails"
                            >
                                {{ $t('instance.instance_list.create_instance.btnCreate') }}
                            </v-btn>
                        </div>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import { isEqual } from 'lodash';
export default {
    components: {
        NsLoader
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        // TODO send it trough this props
        instanceSelected: {
            type: Object,
            required: false,
            default: () => {}
        },
        instances: {
            type: Array,
            required: true,
        },
        modelisations: {
            type: Array,
            required: true,
        },
    },

    data: function(){
        return {
            instanceDetailsFormValid: false,
            instanceName: '',
            instanceNameRules: [
                v => !!v || this.$t('instance.instance_list.create_instance.instanceNameRules')
            ],
            adminEmail: '',
            emailRegex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            adminEmailRules: [
                v => !!v || this.$t('instance.instance_list.create_instance.adminEmailRules'),
                v => {
                    let values = v.match(this.emailRegex);
                    if (values) {
                        return true;
                    }
                    return this.$t('instance.instance_list.create_instance.adminEmailRules_format');
                }
            ],
            selectedVersion: this.modelisations[0].uid,
            selectedVersionRules: [
                v => !!v || this.$t('instance.instance_list.create_instance.selectedVersionRules')
            ],
            wantedStateIsOnline: true,
            sendingRequest: false,
        };
    },

    computed: {
        isOpened() {
            return this.open;
        },
        ...mapGetters([
            'getCurrentApplication'
        ]),
        sortedModelisation(){
            let sortedModelisationByCreationDate = this.modelisations.sort((a,b) => new Date(b.creation_date)-new Date(a.creation_date));
            return sortedModelisationByCreationDate;
        }
    },

    mounted: function(){
        if (this.instanceSelected.uid) {
            this.instanceName = this.instanceSelected.label;
            this.adminEmail = this.instanceSelected.user_administrator.email;
            this.selectedVersion = this.instanceSelected.current_modelisation_uid;
            this.wantedStateIsOnline = this.instanceSelected.should_be_online;
        }
    },
    methods: {
        closeDialog() {
            this.resetForm();
            this.$emit('closeDialog', {refresh: false});
        },
        dataError(error) {
            console.error(error);
        },
        resetForm() {
            this.instanceName = '';
            this.adminEmail = '';
            this.wantedStateIsOnline = true;
            this.selectedVersion = this.modelisations[0].uid;
        },
        inputEvent() {
            this.resetForm();
            this.$emit('closeDialog', {refresh: false});
        },
        validateDetails() {
            if (this.$refs.detailsForm.validate()) {
                this.sendingRequest = true;
                let payload = {
                    item: {
                        label: this.instanceName,
                        application_uid: this.getCurrentApplication.uid,
                        current_modelisation_uid: this.selectedVersion,
                        user_administrator: {
                            email: this.adminEmail,
                        },
                        should_be_online: this.wantedStateIsOnline,
                    },
                    model: 'instances',
                };
                let method = 'patchItem';
                if (!this.instanceSelected.uid) {
                    method = 'createItem';
                    payload.url = this.$store.state.api.meta.listModels.instances.url;
                    payload.scopes = this.$store.state.api.scopes || {};
                }
                else {
                    payload.item.url = this.instanceSelected.url;
                }
                this.$store.dispatch(method, payload).then(() => {
                    this.resetForm();
                    this.$emit('closeDialog', {refresh: true});
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.sendingRequest = false;
                });
            }
        }
    },
};
</script>

<style lang="scss">
.create-instance {
    .select-label {
        display: block;
        margin-bottom: 8px;
    }
}
.create-instance-dialog {
    .v-card__title {
        padding: 24px 32px 16px;
    }
    .title-container{
        align-items: baseline;
        justify-content: space-between;
    }
}
#create-instance-container {
    padding: 0 32px 25px;
}
#create-instance-header {
    padding: 12px;
    background-color: #f35e48;
    color: white;
    font-size: 16px;
    .layout {
        margin: 0;
        .centered-button {
            text-align: center;
        }
    }
    .button{
        background-color: white;
        color: #f35e48;
    }
}
.create-instance-title {
    font-weight: 300;
    font-size: 24px;
    margin-bottom: 20px;
    margin-top: 49px;
    font-weight: 400;
}
.create-instance-headline {
    font-weight: normal;
    font-size: 24px;
    color: $main-light-color;
}
.create-instance-select-label {
    margin-right: 2px;
    color: #2196F3;
    font-size: 16px;
    line-height: 21px;
}
.tooltip-icone{
        color: 0000;
        border-radius: 10px;
        text-align: center;
        font-size: 12px;
        cursor: help;
    }
    .tooltip{
        padding: 2px 5px;
        border-radius: 10px;
        position: relative;
        pointer-events: none;
        opacity: 0;
        background-color: #565151;
        color: #ffffff;
        text-align: center;
    }

    .tooltip-icone:hover .tooltip{
        opacity: 1;
        pointer-events: auto;
    }

    .tooltip:before{
        position: absolute;
        content: "";
    }

.create-instance-status-switch {
    .v-label {
        margin-left: 13px;
        margin-top: 5px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.87);
    }
}
.create-instance-save-btn {
    margin: 0;
}
.input-width{
    width: 100%;
}
.btn-margin{
    margin-right: 1em;
}
.email-descr-container{
    background-color: #FFF3E0;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    .email-description {
        color: #FF9800;
        font-size: 13px;
        margin-left: 19px;
        font-weight: 600;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/InstanceList/create-instance.vue